export default __webpack_public_path__ + "static/media/robot-yellow.04fb86c0.svg";